import { useContext } from 'react';

import { PDFDataContext } from '../../../../context';
import { useColumns } from '../functions';

export function useFlightTable() {
  const { page } = useContext(PDFDataContext);
  const { flights: days } = page.travelBrief;
  const columns = useColumns({ isFlightTable: true });

  return { days, columns };
}
